import { useContext, useCallback } from 'react';
import { AjaxContext, GAME_NAMES } from 'commons-ui';
import { IZupeeKheloJeetoUploadAnswers, IZupeeKheloJeetoUploadQnA } from '../model';

const useService = () => {
	const { postData } = useContext(AjaxContext);

	const requestUploadAddQuestions = useCallback(
		(appName: string, questionDetails: IZupeeKheloJeetoUploadQnA, gameName: string = GAME_NAMES.ZKJ.toLowerCase()) => {
			return postData({
				endpoint: '/marketing/dashboard/zupeeKheloJeeto/uploadQuestions',
				body: { questionDetails, gameName },
				queryParams: { appName }
			});
		},
		[]
	);

	const requestUploadAnswers = useCallback(
		(appName: string, answerDetails: IZupeeKheloJeetoUploadAnswers, gameName: string = GAME_NAMES.ZKJ.toLowerCase()) => {
			return postData({
				endpoint: '/marketing/dashboard/zupeeKheloJeeto/uploadAnswers',
				body: { answerDetails: answerDetails.answers, constraintId: answerDetails.constraintId, gameName },
				queryParams: { appName }
			});
		},
		[]
	);

	return {
		requestUploadAddQuestions,
		requestUploadAnswers
	};
};
export default useService;
